<template lang="pug">
.rb-dynamic-sidebar
  Drawer(
    v-if="sidebar"
    @hide="sidebar = null"
    :title="sidebar.props.title"
    :theme="sidebar.props.theme"
    :width="sidebar.props.width"
  )
    RenderBlock(:block="sidebar.slots.default" :product="entity")
</template>
<script setup lang="ts">
import { ref } from 'vue'

type SidebarBlock = {
  props: {
    id: string
    title?: string
    theme?: string | null
    width?: number
  }
  slots: { default?: any }
}

const props = defineProps<{
  entity: { roguebuilder?: { slots?: { sidebars?: SidebarBlock[] } } }
}>()

const sidebar = ref<SidebarBlock | null>(null)

function show(name: string) {
  const found = props.entity?.roguebuilder?.slots?.sidebars?.find((sb) => sb.props.id === name)

  if (!found) {
    return
  }

  sidebar.value = found
}

function checkClick(event: Event) {
  if (!(event.target instanceof HTMLElement)) {
    return
  }

  const href = event.target.closest('a')?.getAttribute('href') || event.target.closest('button')?.getAttribute('data-link')

  if (!href || !href.startsWith('#') || href === '#') {
    return
  }

  const found = props.entity?.roguebuilder?.slots?.sidebars?.find((sb) => sb.props.id === href.substring(1))

  if (!found) {
    return
  }

  event.preventDefault()
  event.stopPropagation()

  sidebar.value = found
}

defineExpose({ show, checkClick })
</script>
